var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hide_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 22 20",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".hide_svg__st0{fill:#666}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hide_svg__st0",
    d: "M10.2 3C5.3 3 1.2 5.6 0 9.2c1.2 3.6 5.3 6.2 10.2 6.2s9-2.6 10.2-6.2C19.2 5.6 15.1 3 10.2 3zm0 11c-2.4 0-4.4-2.2-4.4-4.8 0-2.7 2-4.8 4.4-4.8 2.4 0 4.4 2.2 4.4 4.8 0 2.7-2 4.8-4.4 4.8zm0-7.9c-1.5 0-2.8 1.4-2.8 3.1s1.2 3.1 2.8 3.1S13 10.9 13 9.2s-1.3-3.1-2.8-3.1z",
    transform: "translate(1 1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-40 12.024 8.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hide_svg__a",
    transform: "rotate(180 10.149 9.036)",
    className: "hide_svg__st0",
    d: "M-1.4 8h23v2h-23z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(140 10.467 9.718)",
    fill: "none",
    stroke: "#f7f7f7",
    d: "M-1.9 7.5h24v3h-24z"
  })));
}
export default SvgHide;